export default __webpack_public_path__ + "524f8f2353dd921be4fb552725de6557.png";